export let UNIT_ID = 1;
export const GRID_SIZE = 40;
export const GAME_SPEED = 1;
export const WORLD_WIDTH = 10000;
export const WORLD_HEIGHT = 10000;

export const unitID = () => UNIT_ID++;

export const CODE_AGAINST_PROD = true;

export const SHOW_MOVEMENT_PILLARS = false;